
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity/[...slug]",
      function () {
        return require("private-next-pages/activity/[...slug].tsx");
      }
    ]);
  